"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentTypes = exports.NutritionTypes = void 0;
const moment_1 = __importDefault(require("moment"));
const _1 = require(".");
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
var NutritionTypes;
(function (NutritionTypes) {
    NutritionTypes[NutritionTypes["MEAL"] = 0] = "MEAL";
    NutritionTypes[NutritionTypes["SNACK"] = 1] = "SNACK";
})(NutritionTypes = exports.NutritionTypes || (exports.NutritionTypes = {}));
var ComponentTypes;
(function (ComponentTypes) {
    ComponentTypes["MULTILINE"] = "multiline";
    ComponentTypes["TIME"] = "time";
    ComponentTypes["MULTIPLE_CHOICE"] = "multiple_choice";
    ComponentTypes["CHECKLIST"] = "checklist";
    ComponentTypes["CONFIRMATION"] = "confirmation";
    ComponentTypes["DIVIDER"] = "divider";
    ComponentTypes["MARKDOWN"] = "markdown";
    ComponentTypes["MARKDOWN_TEMPLATE"] = "markdown_template";
    ComponentTypes["VIDEO"] = "video";
    ComponentTypes["AUDIO"] = "audio";
    ComponentTypes["DURATION"] = "duration";
    ComponentTypes["NUTRITION"] = "nutrition";
    ComponentTypes["UPLOADER"] = "uploader";
    ComponentTypes["UNDEFINED"] = "";
})(ComponentTypes = exports.ComponentTypes || (exports.ComponentTypes = {}));
class Container extends base_1.default {
    constructor(data = {
        id: undefined,
        reference_id: undefined,
        value: undefined,
        friendly_name: undefined,
        reference_friendly_name: undefined,
        component: ComponentTypes.UNDEFINED,
        options: [],
        icon: undefined,
        video: undefined,
        audio: undefined,
        optional: undefined,
        autocomplete_value: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.reference_id = (0, defaults_1.defaultString)(data.reference_id);
        this.value = (0, defaults_1.defaultString)(data.value);
        this.friendly_name = (0, defaults_1.defaultString)(data.friendly_name);
        this.reference_friendly_name = (0, defaults_1.defaultString)(data.reference_friendly_name);
        this.order = (0, defaults_1.defaultNumber)(data.order);
        this.component = data.component;
        this.options = data.options.map((opt) => new _1.Option(opt));
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.video = new _1.Video((0, defaults_1.defaultObject)(data.video));
        this.audio = new _1.Audio((0, defaults_1.defaultObject)(data.audio));
        this.optional = (0, defaults_1.defaultBoolean)(data.optional);
        this.autocomplete_value = (0, defaults_1.defaultString)(data.autocomplete_value);
    }
    get componentType() {
        return this.component;
    }
    get referenceID() {
        return this.reference_id;
    }
    get referenceFriendlyName() {
        return this.reference_friendly_name;
    }
    get friendlyName() {
        return this.friendly_name;
    }
    get getName() {
        return this.id;
    }
    get hasAutoCompleteValue() {
        return !!this.autocomplete_value;
    }
    get defaultValue() {
        if (this.componentType === ComponentTypes.TIME) {
            return (0, moment_1.default)(new Date()).format('hh:mm a').toUpperCase();
        }
        if (this.componentType === ComponentTypes.DURATION) {
            return '0:01';
        }
        if (this.componentType === ComponentTypes.CONFIRMATION) {
            return false;
        }
        if (this.componentType === ComponentTypes.MULTIPLE_CHOICE || this.componentType === ComponentTypes.NUTRITION
            || (this.componentType === ComponentTypes.CHECKLIST && this.referenceID)) {
            return [];
        }
        if ([ComponentTypes.CHECKLIST].includes(this.componentType)) {
            return [{ value: '' }];
        }
        return '';
    }
    get autoCompleteValue() {
        try {
            return JSON.parse(this.autocomplete_value);
        }
        catch {
            return this.defaultValue;
        }
    }
    get numberValue() {
        const intValue = parseInt(this.value, 10);
        return intValue || 0;
    }
}
exports.default = Container;
